const DIRECTIONS = {
  PRECEDING: 2,
  FOLLOWING: 4,
};

/*
  Returns data-id and data-entity attributes from tree
*/
const getSelectionAttributes = (node, attributes = {}) => {
  let newAttributes = attributes;

  if (!node) {
    return {};
  }

  if (node.attributes && node.attributes['data-id'] && node.attributes['data-entity']) {
    return {
      ...attributes,
      entityId: node.attributes['data-id'].value,
      entityType: node.attributes['data-entity'].value,
      node,
    };
  }

  if (node.attributes && node.attributes['data-char-start']) {
    newAttributes = {
      ...newAttributes,
      charStart: parseInt(node.attributes['data-char-start'].value, 10),
      node,
    };
  }

  return getSelectionAttributes(node.parentNode, newAttributes);
};

/*
  Returns all elements within a selection
*/
const getSelectionElements = (parentNode) => {
  if (!parentNode) return [];
  return parentNode.getElementsByClassName('piece-highlighted');
};

/*
  Returns the initial selection position in selected text
*/
const getFirstSelectionOffset = (selection, elements) => {
  const direction = selection.anchorNode.compareDocumentPosition(selection.focusNode);
  let anchor = selection.anchorNode;
  let { anchorOffset } = selection;
  if (direction === DIRECTIONS.PRECEDING) {
    anchor = selection.focusNode;
    anchorOffset = selection.focusOffset;
  }
  for (let i = 0; i < elements.length; i++) { // eslint-disable-line no-plusplus
    const current = elements[i];
    if (selection.containsNode(current, true)) {
      const charStart = parseInt(current.attributes['data-char-start'].value, 10);
      if (current.isEqualNode(anchor.parentNode)) {
        return charStart + anchorOffset;
      }
      return charStart;
    }
  }
  return 0;
};

/*
  Returns the final selection position in selected text
*/
const getLastSelectionOffset = (selection, elements) => {
  const direction = selection.anchorNode.compareDocumentPosition(selection.focusNode);
  let focus = selection.focusNode;
  let { focusOffset } = selection;
  if (direction === DIRECTIONS.PRECEDING) {
    focus = selection.anchorNode;
    focusOffset = selection.anchorOffset;
  }
  for (let i = elements.length - 1; i >= 0; i--) { // eslint-disable-line no-plusplus
    const current = elements[i];
    if (selection.containsNode(current, true)) {
      const charStart = parseInt(current.attributes['data-char-start'].value, 10);
      if (current.isEqualNode(focus.parentNode)) {
        return charStart + focusOffset;
      }
      return charStart + current.innerText.length;
    }
  }
  return 0;
};

export {
  getFirstSelectionOffset,
  getLastSelectionOffset,
  getSelectionAttributes,
  getSelectionElements,
};
